export let measurementDropDownListProps = {
    key: 0,
    id: 0,
    measurement_value: '',
    measurement_instruction_image: ''
}

export let measurementListProps = {
    sl_no: 0,
    id: 0,
    measurement_name: '',
    measurement_value_fixed: false,//single-line, dropdown-list
    measurement_instruction_image: '',
    is_common: false,
    category_name_list: [],
    measurement_drop_down_list: [JSON.parse(JSON.stringify(measurementDropDownListProps))],
    deleted_measurement_drop_down_list_items: []
}

export let dataProps = {
    category_id: null, 
    measurement_list: [JSON.parse(JSON.stringify(measurementListProps))],
    deleted_measurement_list_items: []
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementTemplate/properties.js